import * as TK from 'components/Cart/Details/components/FulfillmentInformation/Recipient/SaveEdit/translations/save-edit.locale.constants';

export const saveEditCommonLocale = {
  [TK.SAVE]: 'Save Changes',
  [TK.CANCEL]: 'Cancel',
  [TK.REDIRECTING]: 'Redirecting...',
  [TK.SUBMITTING]: 'Submitting...',
};
